import { render, staticRenderFns } from "./AutoEmail.vue?vue&type=template&id=bbf3829e&lang=pug"
import script from "./AutoEmail.vue?vue&type=script&lang=js"
export * from "./AutoEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports